let splashes = document.querySelectorAll(".splash")
let langs = document.querySelector(".Splashscreen>.Langs")

let loaded = false

window.addEventListener("load", () => {
    loaded = true
})

if (!sessionStorage.getItem('splashed')) {
    noscroll()
    langSelecterInit()
    splashes.forEach((splash) => {
        splash.classList.add("splash-is-on")
    })
    sessionStorage.setItem('splashed', true);

    //スプラッシュ最低時間を越したら、読み込んでるか確認してスプラッシュを消す
    // setTimeout(() => {
    // }, 3300)

} else {
    setTimeout(() => {
        document.body.classList.add("splashed")
    }, 150)
}

function langSelecterInit() {
    langs.querySelectorAll(".lang").forEach((lang) => {
        lang.querySelector("a").addEventListener("click", (e) => {
            if (lang.classList.contains("is-on")) {
                e.preventDefault()
            }
            canifinishsplash()
        })
    })
}

function canifinishsplash() {
    if (!loaded) {
        setTimeout(() => {
            canifinishsplash()
        }, 100)
    } else {
        document.body.classList.add("splash-can-be-finished")
        document.removeEventListener('touchmove', disableScroll, {
            passive: false
        });
        document.removeEventListener('mousewheel', disableScroll, {
            passive: false
        });
    }
}

function noscroll() {
    document.addEventListener('touchmove', disableScroll, {
        passive: false
    });
    document.addEventListener('mousewheel', disableScroll, {
        passive: false
    });
}

function disableScroll(event) {
    event.preventDefault();
}